import { render, staticRenderFns } from "./SectionMenuForm.vue?vue&type=template&id=5596525f&scoped=true"
import script from "./SectionMenuForm.vue?vue&type=script&lang=js"
export * from "./SectionMenuForm.vue?vue&type=script&lang=js"
import style0 from "./SectionMenuForm.vue?vue&type=style&index=0&id=5596525f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5596525f",
  null
  
)

export default component.exports